import {IComponentController} from "angular";
import "./Customers.scss";

export class CustomersController implements IComponentController {

    public static instance = [
        CustomersController
    ];


}